import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const NoOfSeats = ({ noOfSeats }: SpecProps<"no_of_seats">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (noOfSeats == null || noOfSeats === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.common.noOfSeats",
    message: "Number of seats",
    comment: "Field for 'number of seats' in ad specification",
  });
  const value = formatNumber(noOfSeats, locale);
  return <FieldValuePair field={field} value={value} />;
};
